// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"d7624e82","570":"247f9c03","840":"eb1c6313","953":"4921ee46","967":"b0073a2b"}[chunkId] + ".chunk.css";
};